import type { FluxErrorEntityErrorCodes } from '../types.js';

export const TemplateErrorCodes = {
  TemplateAlreadyAttached: {
    code: 'template/already-attached',
    message: 'Este template já está anexado a essa etapa.',
    explanation: 'Este template já está anexado a esta etapa e não pode ser anexado novamente.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configuração da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
      {
        name: 'Modelos',
        path: '/wiki/docs/pipe/templates/intro',
      },
    ],
  },
  TemplateAttachExceedsMaxDepth: {
    code: 'template/attach-exceeds-max-depth',
    message:
      'Não é possível anexar o template a outro template, pois o número máximo de níveis foi atingido.',
    explanation:
      'Anexar este template excederia a profundidade máxima de aninhamento de templates. Templates podem ser dependentes de outros templates, mas há um limite para evitar complexidade excessiva.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  TemplateDuplicateLabels: {
    code: 'template/duplicate-labels',
    message: 'Uma ou mais etiquetas já existem no template.',
    explanation:
      'Uma ou mais etiquetas que você está tentando adicionar a este template já existem.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Modelos',
        path: '/wiki/docs/pipe/templates/intro',
      },
    ],
  },
  TemplateNotAttached: {
    code: 'template/not-attached',
    message: 'Este template não está anexado a essa etapa.',
    explanation: 'Este template não está anexado a esta etapa e não pode ser removido.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configuração da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
      {
        name: 'Modelos',
        path: '/wiki/docs/pipe/templates/intro',
      },
    ],
  },
  TemplateNotFound: {
    code: 'template/not-found',
    message: 'Template não encontrado.',
    explanation: 'O template que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
  TemplateTaskCreateFailed: {
    code: 'template/template-task-create-failed',
    message: 'Erro ao criar o template.',
    explanation:
      'Ocorreu um erro ao tentar criar a tarefa de template. Verifique as informações e tente novamente.',
    localizations: {},
  },
  TemplateTaskNotFound: {
    code: 'template/template-task-not-found',
    message: 'Template não encontrado.',
    explanation: 'A tarefa de template que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'template'>;

export const TemplateReviewErrorCodes = {
  TemplateReviewDuplicateReviewer: {
    code: 'template-review/duplicate-reviewer',
    message: 'Este aprovador já foi adicionado à solicitação.',
    explanation:
      'O revisor que você está tentando adicionar a este modelo de revisão já foi adicionado.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Modelos de Aprovação',
        path: '/wiki/docs/pipe/templates/reviews',
      },
    ],
  },
  TemplateReviewExistsInStage: {
    code: 'template-review/exists-in-stage',
    message: 'Este modelo de aprovação já está vinculado a esta etapa.',
    explanation:
      'Este modelo de revisão já está vinculado a esta etapa. Cada etapa só pode vincular o mesmo modelo uma vez.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Modelos de Aprovação',
        path: '/wiki/docs/pipe/templates/reviews',
      },
      {
        name: 'Configuração da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  TemplateReviewInvalidReviewerPosition: {
    code: 'template-review/invalid-reviewer-position',
    message: 'A posição do aprovador é inválida.',
    explanation: 'A posição do revisor no modelo de revisão é inválida.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Modelos de Aprovação',
        path: '/wiki/docs/pipe/templates/reviews',
      },
    ],
  },
  TemplateReviewNotFound: {
    code: 'template-review/not-found',
    message: 'A solicitação de aprovação não foi encontrada.',
    explanation: 'O modelo de revisão que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
  TemplateReviewRequiredReviewer: {
    code: 'template-review/required-reviewer',
    message: 'É necessário adicionar pelo menos um aprovador à solicitação.',
    explanation: 'É necessário adicionar pelo menos um revisor a este modelo de revisão.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Modelos de Aprovação',
        path: '/wiki/docs/pipe/templates/reviews',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'template-review'>;
